import { ElementRef, InjectionToken } from '@angular/core';

export const OVERLAY_ANCHOR_ELEMENT = new InjectionToken<ElementRef>(
  'Overlay anchor element for positioning',
);
